import {
  useState,
  useCallback,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { Slate, Editable, withReact } from 'slate-react'
import { createEditor, Transforms, Editor, Node } from 'slate'
import { withHistory } from 'slate-history'

import { withPrompt, convertToSlateNodes } from './plugin'

import styles from './index.module.less'

const PromptEditor = forwardRef(({ markText }: any, ref) => {
  const editor = useMemo(
    () => withHistory(withReact(withPrompt(createEditor()))),
    [],
  )
  const initNodes = useMemo(() => convertToSlateNodes(markText), [markText])
  const [value, setValue] = useState(initNodes)
  const [active, setActive] = useState('')

  const renderElement = useCallback(
    (props: any) => {
      const { attributes, element, children } = props
      if (element.type === 'highlightInput') {
        const isActive = active === Node.string(element)
        return (
          <span
            {...attributes}
            className={`${styles.highlightInput} ${
              isActive ? styles.active : ''
            }`}
          >
            {children}
          </span>
        )
      } else {
        return children
      }
    },
    [active],
  )

  useImperativeHandle(ref, () => ({
    value,
    text: value?.map(item => Node.string(item)).join(''),
  }))

  return (
    <Slate
      editor={editor}
      value={value}
      onChange={(newVal: any) => {
        setValue(newVal)
        // 获取当前光标所在的节点，如果是高亮输入框，则修改节点的样式
        const [match] = Editor.nodes(editor, {
          match: (n: any) => n.type === 'highlightInput',
        })
        if (match) {
          const [node, path] = match
          const text = Node.string(node)
          if (!text) {
            Transforms.unwrapNodes(editor, {
              at: path,
            })
          }
          setActive(text)
        } else {
          setActive('')
        }
      }}
    >
      <Editable
        className={styles.editerArea}
        renderElement={renderElement}
        placeholder="请输入指令"
      />
    </Slate>
  )
})

export default PromptEditor
